import { useSetAtom } from 'jotai'
import React, { useState } from 'react'
import { TransactionResult } from 'src/common/contracts/hooks/useExecuteTx'
import Modal, { ModalProps } from 'src/common/ui-kit/Modal'

import CarbonBundleSuccess from '../components/CarbonBundleSuccess'
import { viccCountAtom, withdrawnNFTsAtom } from '../bundle-store'
import CarbonBundleWithdraw from './CarbonBundleWithdraw'

enum View {
  Select,
  Deposit,
  Success,
}

const CarbonBundleWithdrawModal: React.FC<ModalProps> = props => {
  const [tx, setTx] = useState<TransactionResult>()
  const [view, setView] = useState<View>(View.Deposit)

  const setWithdrawnNFTs = useSetAtom(withdrawnNFTsAtom)
  const setViccCount = useSetAtom(viccCountAtom)

  const isDepositView = view === View.Deposit
  const isSuccessView = view === View.Success

  const handleSuccess = (tx: TransactionResult) => {
    setTx(tx)
    setView(View.Success)
  }

  const resetStore = () => {
    setWithdrawnNFTs([])
    setViccCount(0)
  }

  const handleClose = () => {
    setView(View.Deposit)
    props.onClose?.()
    resetStore()
  }

  return (
    <Modal {...props} onClose={handleClose}>
      {isDepositView && <CarbonBundleWithdraw onSuccess={handleSuccess} />}
      {isSuccessView && tx && (
        <CarbonBundleSuccess tx={tx} onClose={handleClose} mode='withdraw' />
      )}
    </Modal>
  )
}

export default CarbonBundleWithdrawModal
